// import React, { useState } from 'react';
// import './Loginandregister.css';
// import { Link, NavLink, useNavigate } from "react-router-dom";
// import { validateEmail } from '../Utils/Validation';
// import { auth, db } from "../firebase/firebase"; // Import Firestore
// import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth'; // Import updateProfile
// import { doc, setDoc } from "firebase/firestore"; // Firestore functions
// import Loading from '../Loader/Loadering';

// export default function Register() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [userName, setUserName] = useState(''); // Add state for username
//   const [isEmailValid, setIsEmailValid] = useState(true);
//   const [passwordError, setPasswordError] = useState('');
//   const [loading, setLoading] = useState(false); // Loader state

//   const navigate = useNavigate();

//   const handleEmailChange = (event) => {
//     validateEmail(event.target.value, setEmail, setIsEmailValid);
//   };

//   const handleInputPasswordChange = (event) => {
//     const value = event.target.value;
//     setPassword(value);
//     if (value.length < 8) {
//       setPasswordError('Your password is less than 8 characters. Please set a password greater than 8 characters.');
//     } else {
//       setPasswordError('');
//     }
//   };

//   const handleRegister = async (event) => {
//     event.preventDefault();
//     if (isEmailValid && email && password.length >= 8) {
//       setLoading(true); // Loader start
//       try {
//         // Create user with Firebase Auth
//         const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//         const user = userCredential.user;

//         // Update Firebase Authentication profile with displayName
//         await updateProfile(user, {
//           displayName: userName, // Set displayName to username
//         });

//         // Save user data in Firestore
//         await setDoc(doc(db, "users", user.uid), {
//           userName: userName,
//           email: email,
//           password: password, // Note: Storing passwords in Firestore is not recommended for production
//           timestamp: new Date().toISOString(),
//         });

//         alert('Registered Successfully.');
//         navigate('/login');
//       } catch (error) {
//         setLoading(false); // Ensure loader stops when error occurs
//         if (error.code === 'auth/email-already-in-use') {
//           alert('That email address is already in use!');
//         } else {
//           alert(`Error: ${error.message}`);
//         }
//         console.error('Error registering user:', error.message);
//       } finally {
//         setLoading(false); // Hide Loader after login attempt
//       }
//     }
//   };

//   return (
//     <>
//       <div className='Background'>
//         <div className='auth-formside'>
//           <form onSubmit={handleRegister}>
//             <h2>Register.</h2>

//             <label> Username </label>
//             <div className="wrapper">
//               <i className="ri-user-3-line"></i>
//               <input
//                 type='text'
//                 name='username'
//                 placeholder='John'
//                 value={userName}
//                 onChange={(e) => setUserName(e.target.value)} // Add onChange for username
//                 required
//               />
//             </div>

//             <label> Email address </label>
//             <div className="wrapper">
//               <i className="ri-mail-line"></i>
//               <input
//                 type='text'
//                 name='email'
//                 placeholder='john@gmail.com'
//                 value={email}
//                 onChange={handleEmailChange}
//                 required
//               />
//             </div>
//             {!isEmailValid && email !== '' && (
//               <div style={{ color: 'red', fontSize: '15px' }}>
//                 Email wrong formatting
//               </div>
//             )}
//             {isEmailValid && email !== '' && (
//               <div style={{ color: 'green', fontSize: '15px' }}>
//                 Excellent
//               </div>
//             )}

//             <label> Password </label>
//             <div className="wrapper">
//               <i className="ri-lock-line"></i>
//               <input
//                 type='text'
//                 name='password'
//                 placeholder='your password'
//                 onChange={handleInputPasswordChange}
//                 required
//               />
//             </div>
//             {passwordError && password !== '' && (
//               <div style={{ color: 'red', fontSize: '15px' }}>
//                 {passwordError}
//               </div>
//             )}

//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '107%', marginTop: "10px", gap: '5px' }}>
//               <input
//                 type="checkbox"
//                 id="agreeTerms"
//                 required
//               />
//               <label className='terms-pri' style={{ margin: 0 }}>
//                 I agree to the platform's <Link to="/termsofservice" className='navlink'>Terms of Service</Link> and <Link to="/privcypolicy" className='navlink'>Privcy policy</Link>.
//               </label>
//             </div>

//             <button type="submit" disabled={loading} style={{ marginTop: '1.5rem' }}>
//               {loading && <Loading />}
//               Register
//             </button>
//             <p>Already have an account? <NavLink to="/login" className='navlink'>Login</NavLink></p>
//           </form>
//         </div>

//         <div className='registerimageside'>
//           {/* <p>Start For Free & Get Attractive Offers.</p> */}
//         </div>
//       </div>
//     </>
//   );
// }

import React, { useState } from 'react';
import './Authentication.css'; // Use the same CSS file as Login
import { Link, NavLink, useNavigate } from "react-router-dom";
import { validateEmail } from '../Utils/Validation';
import { auth, db } from "../firebase/firebase";
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, setDoc } from "firebase/firestore";
import Loading from '../Loader/Loadering';
import InputField from './InputField'; // Import InputField component
import SocialLogin from './SocialLogin'; // Import SocialLogin component
import { motion } from "framer-motion";

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userName, setUserName] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [passwordError, setPasswordError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleEmailChange = (event) => {
    validateEmail(event.target.value, setEmail, setIsEmailValid);
  };

  const handleInputPasswordChange = (event) => {
    const value = event.target.value;
    setPassword(value);
    if (value.length < 8) {
      setPasswordError('Your password is less than 8 characters. Please set a password greater than 8 characters.');
    } else {
      setPasswordError('');
    }
  };

  const handleRegister = async (event) => {
    event.preventDefault();
    if (isEmailValid && email && password.length >= 8) {
      setLoading(true); // Show Loader
      try {
        // Create user with Firebase Auth
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;

        // Update Firebase Authentication profile with displayName
        await updateProfile(user, {
          displayName: userName,
        });

        // Save user data in Firestore
        await setDoc(doc(db, "users", user.uid), {
          userName: userName,
          email: email,
          timestamp: new Date().toISOString(),
        });

        alert('Registered Successfully.');
        navigate('/login');
      } catch (error) {
        setLoading(false); // Hide Loader on error
        if (error.code === 'auth/email-already-in-use') {
          alert('That email address is already in use!');
        } else {
          alert(`Error: ${error.message}`);
        }
        console.error('Error registering user:', error.message);
      } finally {
        setLoading(false); // Hide Loader after registration attempt
      }
    }
  };

  return (
    <div className="auth-container">
      <motion.div className="login-container"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <SocialLogin />
        <h2 className="form-title">Sign up</h2>
        <p className="separator"><span>or</span></p>
        <form onSubmit={handleRegister} className="login-form">
          <InputField
            type="text"
            placeholder="Username"
            icon="person"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />
          <InputField
            type="email"
            placeholder="Email address"
            icon="mail"
            value={email}
            onChange={handleEmailChange}
          />
          {!isEmailValid && email !== '' && (
            <div style={{ color: 'red', fontSize: '15px' }}>
              Email wrong formatting
            </div>
          )}
          {isEmailValid && email !== '' && (
            <div style={{ color: 'green', fontSize: '15px' }}>
              Excellent
            </div>
          )}
          <InputField
            type="password"
            placeholder="Password"
            icon="lock"
            value={password}
            onChange={handleInputPasswordChange}
          />
          {passwordError && password !== '' && (
            <div style={{ color: 'red', fontSize: '15px' }}>
              {passwordError}
            </div>
          )}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', marginTop: '10px', gap: '5px' }}>
            <input
              type="checkbox"
              id="agreeTerms"
              required
              className='checkbox'
              
            />
            <label className='terms-pri' style={{ margin: 0 }}>
              I agree to the platform's <Link to="/termsofservice" className='navlink'>Terms of Service</Link> and <Link to="/privcypolicy" className='navlink'>Privacy Policy</Link>.
            </label>
          </div>
          <motion.button 
            type="submit" 
            className="login-button" 
            disabled={loading}
            whileHover={{ scale: 1.05 }} // Hover effect
            whileTap={{ scale: 0.95 }} // Tap effect
            transition={{ duration: 0.3, ease: "easeOut" }}
            >
            {loading && <Loading />}
            Register
          </motion.button>
        </form>
        <p className="signup-prompt">
          Already have an account? <NavLink to="/login" className="signup-link">Login</NavLink>
        </p>
      </motion.div >
    </div>
  );
}